import React from "react";

export default props => (
  <svg
    {...props}
    viewBox="0 0 18 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Canvas" transform="translate(-555 -2525)">
      <path
        transform="translate(555 2525)"
        d="M 18 9.5C 18 10.3249 17.874 11.119 17.6523 11.875L 15.9333 11.875C 16.2074 11.1308 16.3636 10.3336 16.3636 9.5C 16.3636 5.57175 13.0606 2.375 9 2.375C 7.60418 2.375 6.30327 2.75817 5.19136 3.41525L 6.71155 5.54167L 0.989182 5.54167L 2.74991 0L 4.26273 2.11613C 5.64055 1.28567 7.25645 0.791667 9 0.791667C 13.9696 0.791667 18 4.69063 18 9.5ZM 12.8013 15.5895C 11.691 16.2434 10.3925 16.625 9 16.625C 4.94018 16.625 1.63636 13.4283 1.63636 9.5C 1.63636 8.66638 1.79264 7.86917 2.06591 7.125L 0.347727 7.125C 0.126 7.88104 1.81673e-16 8.67508 1.81673e-16 9.5C 1.81673e-16 14.3094 4.02955 18.2083 9 18.2083C 10.7403 18.2083 12.3537 17.7167 13.7291 16.8886L 15.2452 19L 17.0059 13.467L 11.2835 13.467L 12.8013 15.5895Z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/Loading/index.js